import { jsx } from 'react/jsx-runtime';
import { Alert } from '@zooplus/ui-components';
import styles from './ErrorAlert.module.scss.js';

/**
 * Basic component to display an alert message.
 */
const ErrorAlert = ({ errorMessage, variant = 'error' }) => {
    return errorMessage ? (jsx(Alert, { variant: variant, "data-zta": "errorCreditCard", className: styles.alertWrapper, children: errorMessage })) : null;
};

export { ErrorAlert as default };
//# sourceMappingURL=ErrorAlert.js.map
